var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{class:[
      'footer',
      {
        'footer--hidden': _vm.routeCheck,
      } ]},[_c('ProgressBar'),_c('div',{staticClass:"footer__inner"},[(!_vm.hideNavigation)?_c('div',{staticClass:"footer__controls"},[_c('div',{class:[
            'footer__control',
            'back',
            'first-last',
            {
              'footer__control--disabled':
                _vm.activeDataList.length === 0 || _vm.activeIndex === 0,
            } ],on:{"click":_vm.first}},[_c('SvgControl'),_c('SvgControl')],1),_c('div',{class:[
            'footer__control',
            'back',
            {
              'footer__control--disabled':
                _vm.activeDataList.length === 0 || _vm.activeIndex === 0,
            } ],on:{"click":_vm.prev}},[_c('SvgControl')],1),_c('div',{class:[
            'footer__control',
            {
              'footer__control--disabled':
                _vm.activeDataList.length === 0 ||
                _vm.activeIndex === _vm.activeDataList.length - 1,
            } ],on:{"click":_vm.next}},[_c('SvgControl')],1),_c('div',{class:[
            'footer__control',
            'first-last',
            {
              'footer__control--disabled':
                _vm.activeDataList.length === 0 ||
                _vm.activeIndex === _vm.activeDataList.length - 1,
            } ],on:{"click":_vm.last}},[_c('SvgControl'),_c('SvgControl')],1)]):_vm._e()])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }